module.exports = __webpack_public_path__ + "static/media/football-ball.63cf9876.svg";